export var DEFAULT_CONTEXT_VALUE = {
  state: {
    onNextPress: () => null,
    goToNext: () => null,
    onPreviousPress: () => null,
    goToPrevious: () => null,
    onDotPress: () => null,
    goTo: () => null,
    currentIndex: 0,
    pages: 0,
    infinite: true,
    onSlideChange: () => null,
    color: 'standard'
  },
  setState: () => {}
};
//# sourceMappingURL=CarouselContext.js.map